module.exports = "/_next/static/images/hci_under_ojk_centered_white-20504d9b41e06cd75d47fd649b8144d4.png";